export const SCHEMA_NAME = "Addresses";

export const FIELDS = {
  ADDRESS_ID: "addressID",
  ADDRESS_STREET_1: "addressStreet1",
  ADDRESS_STREET_2: "addressStreet2",
  ADDRESS_CITY: "addressCity",
  ADDRESS_STATE: "addressState",
  ADDRESS_ZIP: "addressZip",
  ADDRESS_TYPE: "addressType",
  ADDRESS_APARTMENT_NUMBER: "addressApartmentNumber",
  ADDRESS_STREET_NUMBER: "addressStreetNumber",
  ADDRESS_STREET_SUFFIX: "addressStreetSuffix",
  COUNTY_OF_RESIDENCE: "countyOfResidence",
  OTHER_COUNTY_OF_RESIDENCE: "otherCountyOfResidence",
  CITY_OF_RESIDENCE: "cityOfResidence",
  OTHER_CITY_OF_RESIDENCE: "otherCityOfResidence",
  TOWNSHIP_OF_RESIDENCE: "townshipOfResidence",
  COMMUNITY: "community",
  SERVICE_AREA: "serviceArea",
  TAX_CODE: "taxCode",
  TEMP_BIO_ID: "tempBioID",
  TEMP_SOURCE_ID: "tempSourceID",
};
